import ErrorLabel from '../../components/error';
export function TextArea({placeholder = '', row = 10,className, onChangeValue , secondary = false, required = false , errorLabel , value , disabled = false, style=null}) {
    let lang = localStorage.getItem("i18nextLng");
    const languageDir = "language-" + lang;
    return (
        <div className={"input " + languageDir + ' ' +  (secondary && "input-secondary")}>
            <ErrorLabel errorTitle={errorLabel}/>
            <textarea style={style} disabled={disabled} placeholder={placeholder}
             className={"input-field "+className}
              onChange={(e)=> onChangeValue(e.target.value)} 
              rows={row} required={required} value={value}></textarea>
        </div>
    );
}
